<section class="min-h-screen">
  <!-- Page Header -->
  <div class="mb-6 flex items-start justify-between">
    <div>
      <button (click)="goBack()"
        class="flex items-center gap-1.5 text-xs font-semibold text-slate-500 dark:text-slate-400 hover:text-primary-800 dark:hover:text-primary-400 transition-colors mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Back to Institutions
      </button>
      <h1 class="text-2xl font-bold tracking-tight text-primary-800 dark:text-primary-400">{{ institution?.name || 'Institution Details' }}</h1>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Member since {{ institution?.createdAt | date: 'MMMM yyyy' }}</p>
    </div>
    <div class="flex items-center gap-2 px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg shadow-sm">
      <span class="inline-flex items-center gap-1.5 text-[11px] font-semibold text-emerald-600">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>Active
      </span>
    </div>
  </div>

    <!-- Navigation Tabs -->
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm mb-6">
      <div class="flex items-center border-b border-slate-200 dark:border-slate-700">
        <button (click)="showOverview()"
          class="px-6 py-3.5 text-xs font-bold transition-all border-b-2 uppercase tracking-wide"
          [class]="currentView === 'overview' ? 'border-primary-800 text-primary-800 dark:text-primary-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:border-slate-600'">
          Overview
        </button>
        <button (click)="showMembers()"
          class="px-6 py-3.5 text-xs font-bold transition-all border-b-2 uppercase tracking-wide"
          [class]="currentView === 'members' ? 'border-primary-800 text-primary-800 dark:text-primary-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:border-slate-600'">
          Members
        </button>
        <button (click)="showApplications()"
          class="px-6 py-3.5 text-xs font-bold transition-all border-b-2 uppercase tracking-wide"
          [class]="currentView === 'applications' ? 'border-primary-800 text-primary-800 dark:text-primary-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:border-slate-600'">
          Product Applications
        </button>
        <button (click)="showProducts()"
          class="px-6 py-3.5 text-xs font-bold transition-all border-b-2 uppercase tracking-wide"
          [class]="currentView === 'products' ? 'border-primary-800 text-primary-800 dark:text-primary-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:border-slate-600'">
          All Products
        </button>
      </div>
    </div>

    <!-- OVERVIEW VIEW -->
    @if (currentView === 'overview') {
    <!-- Institution Information Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <!-- Contact Information -->
      <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5">
        <h3 class="text-sm font-bold uppercase tracking-widest mb-4 text-primary-800 dark:text-primary-400">Contact Information</h3>
        <div class="space-y-3">
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
              </path>
            </svg>
            <div>
              <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium">Email</p>
              <p class="text-sm text-slate-900 dark:text-white break-words">{{ institution?.email || 'N/A' }}</p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
              </path>
            </svg>
            <div>
              <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium">Contact</p>
              <p class="text-sm text-slate-900 dark:text-white">{{ institution?.contact || 'N/A' }}</p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            <div>
              <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium">Address</p>
              <p class="text-sm text-slate-900 dark:text-white break-words">{{ institution?.address || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Details -->
      <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5">
        <h3 class="text-sm font-bold uppercase tracking-widest mb-4 text-primary-800 dark:text-primary-400">Details</h3>
        <div class="space-y-3">
          <div>
            <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium mb-1">Institution Code</p>
            <p class="text-sm text-slate-900 dark:text-white">{{ institution?.code || 'N/A' }}</p>
          </div>
          <div>
            <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium mb-1">Auto Repayment</p>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
              [ngClass]="institution?.autoRepayment ? 'bg-success-light text-success' : 'bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300'">
              {{ institution?.autoRepayment ? 'Enabled' : 'Disabled' }}
            </span>
          </div>
          <div>
            <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium mb-1">Description</p>
            <p class="text-sm text-slate-900 dark:text-white break-words">{{ institution?.description || 'N/A' }}</p>
          </div>
          <div>
            <p class="text-xs text-slate-500 dark:text-slate-400 uppercase font-medium mb-1">Assigned To</p>
            @if (institution?.assignedTo) {
            <p class="text-sm text-slate-900 dark:text-white break-words">
              {{ institution?.assignedTo?.firstName }} {{ institution?.assignedTo?.lastName }} ({{ institution?.assignedTo?.email }})
            </p>
            } @else {
            <p class="text-sm text-slate-900 dark:text-white">—</p>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Documents Section -->
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5 mb-8">
      <h3 class="text-sm font-bold uppercase tracking-widest mb-4 text-primary-800 dark:text-primary-400">Documents</h3>
      @if (institution && institution.documents && institution.documents.length > 0) {
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        @for (docUrl of institution.documents; track $index) {
        <div class="border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden bg-white dark:bg-slate-800 shadow-sm flex flex-col">

          <!-- Preview area -->
          @if (getFileType(docUrl) === 'image') {
          <div class="h-44 bg-slate-50 dark:bg-slate-800/60 flex items-center justify-center overflow-hidden">
            <img [src]="docUrl" [alt]="getFileNameFromUrl(docUrl)"
              class="w-full h-full object-cover" />
          </div>
          } @else if (getFileType(docUrl) === 'pdf') {
          <div class="h-44 bg-slate-50 dark:bg-slate-800/60 overflow-hidden">
            <iframe [src]="getSafeUrl(docUrl)" class="w-full h-full border-0" title="PDF preview"></iframe>
          </div>
          } @else {
          <div class="h-44 bg-slate-50 dark:bg-slate-800/60 flex flex-col items-center justify-center gap-2">
            <svg class="w-12 h-12 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p class="text-xs text-slate-400 font-medium uppercase tracking-widest">{{ docUrl.split('?')[0].split('.').pop() || 'File' }}</p>
          </div>
          }

          <!-- Footer: filename + actions -->
          <div class="px-3 py-2.5 border-t border-slate-100 dark:border-slate-700/50 flex items-center justify-between gap-2">
            <p class="text-xs font-medium text-slate-700 dark:text-slate-300 truncate flex-1">{{ getFileNameFromUrl(docUrl) }}</p>
            <div class="flex items-center gap-1 flex-shrink-0">
              <button (click)="downloadDocument(docUrl)"
                class="p-1.5 text-slate-400 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
                title="Download">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </button>
              <button (click)="openDocModal(docUrl)"
                class="p-1.5 text-slate-400 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
                title="View document">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="text-center py-8">
        <svg class="w-12 h-12 text-slate-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
          </path>
        </svg>
        <p class="text-sm text-slate-500 dark:text-slate-400">No documents available</p>
      </div>
      }
    </div>

    <!-- Document Preview Modal -->
    @if (showDocModal) {
    <div class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-in fade-in duration-300"
      (click)="closeDocModal()">
      <div class="relative w-full max-w-4xl max-h-[90vh] bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] overflow-hidden flex flex-col animate-in zoom-in-95 duration-300"
        (click)="$event.stopPropagation()">
        <!-- Top Brand Glow -->
        <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md flex-shrink-0">
          <p class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest truncate">{{ getFileNameFromUrl(activeDocUrl) }}</p>
          <div class="flex items-center gap-2">
            <button (click)="downloadDocument(activeDocUrl)"
              class="p-1.5 text-slate-400 hover:text-primary-900 hover:bg-white dark:bg-slate-800 rounded-lg transition-colors"
              title="Download">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
            </button>
            <button (click)="closeDocModal()"
              class="p-1.5 text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group"
              title="Close">
              <svg class="w-4 h-4 group-hover:rotate-90 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <!-- Content -->
        <div class="flex-1 overflow-auto min-h-0">
          @if (getFileType(activeDocUrl) === 'image') {
          <div class="flex items-center justify-center p-4 h-full">
            <img [src]="activeDocUrl" [alt]="getFileNameFromUrl(activeDocUrl)"
              class="max-w-full max-h-full object-contain rounded-lg" />
          </div>
          } @else if (getFileType(activeDocUrl) === 'pdf') {
          <iframe [src]="getSafeUrl(activeDocUrl)" class="w-full border-0" style="height: 75vh;" title="PDF viewer"></iframe>
          } @else {
          <div class="flex flex-col items-center justify-center py-20 gap-4">
            <svg class="w-16 h-16 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p class="text-sm text-slate-500 dark:text-slate-400">Preview not available for this file type.</p>
            <button (click)="downloadDocument(activeDocUrl)"
              class="px-4 py-2 text-xs font-semibold text-white bg-primary-800 rounded-lg hover:bg-primary-700 transition-colors">
              Download File
            </button>
          </div>
          }
        </div>
      </div>
    </div>
    }
    }

    <!-- MEMBERS VIEW -->
    @if (currentView === 'members') {
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
        <h2 class="text-sm font-bold uppercase tracking-widest text-primary-800 dark:text-primary-400">All Members</h2>
        <div class="flex items-center gap-2">
          <app-export-button (onExportEvent)="handleMemberExport($event)"></app-export-button>
          <button (click)="fetchPaginatedMembers()"
            class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>

            <span>Refresh</span>
          </button>
        </div>
      </div>

      <!-- Search -->
      <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-1 max-w-md">
            <form [formGroup]="memberSearchQuery">
              <app-search [placeholder]="'Search members by name, email or phone...'"
                formControlName="keyword"></app-search>
            </form>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="min-h-[300px] overflow-x-auto">
        <div class="min-w-[900px]">

          <!-- Header -->
          <div class="grid grid-cols-12 gap-x-4 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 px-6 py-3">
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Member</p>
            </div>
            <div class="col-span-1 text-left">
              <p class="text-xs font-semibold text-slate-400">Email</p>
            </div>
            <div class="col-span-1 text-left">
              <p class="text-xs font-semibold text-slate-400">Phone</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Ghana Card</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Account</p>
            </div>
            <div class="col-span-1 text-left">
              <p class="text-xs font-semibold text-slate-400">Income</p>
            </div>
            <div class="col-span-1 text-left">
              <p class="text-xs font-semibold text-slate-400">Status</p>
            </div>
            <div class="col-span-2 text-center">
              <p class="text-xs font-semibold text-slate-400">Actions</p>
            </div>
          </div>

          <!-- Rows -->
          @if (isMembersLoading) {
          <div class="flex items-center justify-center py-16">
            <app-progress-loader></app-progress-loader>
          </div>
          }
          @if (!isMembersLoading) {
          @for (member of members.data; track member.id; let i = $index) {
          <div class="grid grid-cols-12 gap-x-4 px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 items-center transition-colors">

            <!-- Member -->
            <div class="col-span-2 flex items-center justify-start gap-2 min-w-0">
              <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-white text-[10px] font-bold bg-primary-800">
                {{ member?.firstName?.charAt(0) }}{{ member?.lastName?.charAt(0) }}
              </div>
              <div class="min-w-0 text-left">
                <p class="text-xs font-semibold text-slate-900 dark:text-white truncate">{{ member?.firstName }} {{ member?.lastName }}</p>
                @if (member?.otherName) {
                <p class="text-[10px] text-slate-400 truncate">{{ member.otherName }}</p>
                }
                <p class="text-[10px] text-slate-400 font-mono">{{ member?.dateOfBirth | date:'dd MMM yyyy' }}</p>
              </div>
            </div>

            <!-- Email -->
            <div class="col-span-1 min-w-0 text-left">
              <p class="text-[11px] text-slate-700 dark:text-slate-300 truncate">{{ member?.email || '—' }}</p>
            </div>

            <!-- Phone -->
            <div class="col-span-1 text-left">
              <p class="text-[11px] text-slate-600 dark:text-slate-400 font-mono">{{ member?.mobileNumber || '—' }}</p>
            </div>

            <!-- Ghana Card -->
            <div class="col-span-2 min-w-0 text-left">
              @if (member?.ghanaCardNumber) {
              <p class="text-[11px] font-bold text-slate-800 dark:text-slate-100 truncate">{{ member.ghanaCardNumber }}</p>
              <span class="text-[9px] font-bold uppercase"
                [ngClass]="member.isGhanaCardVerified ? 'text-emerald-600' : 'text-slate-400'">
                {{ member.isGhanaCardVerified ? 'Verified' : 'Unverified' }}
              </span>
              } @else {
              <p class="text-[11px] text-slate-400 italic">No ID linked</p>
              }
            </div>

            <!-- Account -->
            <div class="col-span-2 min-w-0 text-left">
              @if (member?.account) {
              <p class="text-[11px] font-bold text-slate-800 dark:text-slate-100">{{ member.account?.accountNumber }}</p>
              <p class="text-[10px] text-slate-400">{{ member.account?.network }} · {{ member.account?.accountType }}</p>
              <p class="text-[10px] text-slate-500 dark:text-slate-400 truncate">{{ member.account?.accountName }}</p>
              } @else {
              <p class="text-[11px] text-slate-400 italic">No account</p>
              }
            </div>

            <!-- Income -->
            <div class="col-span-1 text-left">
              <p class="text-[11px] font-semibold text-slate-700 dark:text-slate-300">GHS {{ member?.monthlyIncome || '0' }}</p>
              @if ((member?.activeLoanSum || 0) > 0) {
              <p class="text-[10px] text-rose-500">₵{{ (member?.activeLoanSum || 0) | number:'1.0-0' }} loans</p>
              }
            </div>

            <!-- Status -->
            <div class="col-span-1 flex justify-start">
              <span class="px-2 py-0.5 rounded-md text-[9px] font-bold border uppercase tracking-widest"
                [ngClass]="member.isActive ? 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900' : 'bg-slate-50 dark:bg-slate-800/60 text-slate-400 border-slate-200 dark:border-slate-700'">
                {{ member.isActive ? 'Active' : 'Inactive' }}
              </span>
            </div>

            <!-- Actions -->
            <div class="col-span-2 flex justify-center items-center gap-0.5">
              <button (click)="viewMember(member)"
                class="px-2 py-1 text-xs font-semibold text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700 rounded hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 hover:border-slate-300 dark:border-slate-600 transition-colors">
                View
              </button>
              @if (permissionService.canManage('institutions')) {
              <button (click)="editMember(member)" title="Edit"
                class="p-1.5 rounded text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              }
              @if (permissionService.canResetPin()) {
              <button (click)="showResetPinConfirmation(member)" title="Reset PIN"
                class="p-1.5 rounded text-slate-400 hover:text-primary-800 dark:hover:text-primary-400 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
              </button>
              }
              @if (permissionService.canManage('institutions')) {
              <button (click)="showDisableConfirmation(member, i)" title="Toggle Status"
                class="p-1.5 rounded text-slate-400 hover:text-amber-600 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                </svg>
              </button>
              <button (click)="showDeleteConfirmation(member, i)" title="Delete"
                class="p-1.5 rounded text-rose-500 hover:text-rose-700 hover:bg-rose-50 transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
              }
            </div>

          </div>
          }
          @if (!isMembersLoading && (!members.data || members.data.length === 0)) {
          <div class="flex flex-col items-center justify-center py-24 text-center">
            <div class="w-16 h-16 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mb-4">
              <img [src]="_images.personRound" alt="" class="w-8 h-8 opacity-20" />
            </div>
            <p class="text-sm font-bold text-slate-800 dark:text-slate-100">No members found</p>
            <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-1 max-w-[240px]">This institution currently has no members registered.</p>
          </div>
          }
          }
        </div>
      </div>

      <!-- Pagination -->
      @if (members.data && members.data.length > 0) {
      <app-pagination [totalItems]="members.meta.total || 0" [itemsPerPage]="members.meta.perPage || 10"
        [currentPage]="members.meta.page || 1" (pageChange)="onMemberPageChange($event)"></app-pagination>
      }
    </div>
    }

    <!-- APPLICATIONS VIEW -->
    @if (currentView === 'applications') {
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
        <h2 class="text-sm font-bold uppercase tracking-widest text-primary-800 dark:text-primary-400">Product Applications</h2>
        <button (click)="fetchPaginatedInstitutionApplication()"
          class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>

          <span>Refresh</span>
        </button>
      </div>

      <!-- Search and Filter -->
      <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-1 max-w-md">
            <form [formGroup]="searchQuery">
              <app-search [placeholder]="'Search applicants...'" formControlName="name"></app-search>
            </form>
          </div>
          <div>
            <app-institution-filter
              [statusOptions]="loanStatusOptions"
              (onSaveEvent)="filterApplications($event)"
              (resetClickEvent)="resetApplicationFilters()">
            </app-institution-filter>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto min-h-[400px]">
        <div class="min-w-[800px]">

          <!-- Header -->
          <div class="grid grid-cols-12 gap-x-4 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 px-6 py-3">
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Date</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Applicant</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Ref / ID</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Product</p>
            </div>
            <div class="col-span-1 text-left">
              <p class="text-xs font-semibold text-slate-400">Amount</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Status</p>
            </div>
            <div class="col-span-1 text-center">
              <p class="text-xs font-semibold text-slate-400">Actions</p>
            </div>
          </div>

          <!-- Rows -->
          @if (isApplicationsLoading) {
          <div class="flex items-center justify-center py-16">
            <app-progress-loader></app-progress-loader>
          </div>
          }
          @if (!isApplicationsLoading) {
          @for (loan of loans.data; track loan.id) {
          <div class="grid grid-cols-12 gap-x-4 px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 items-center transition-colors cursor-pointer group"
            (click)="onViewLoanProduct(loan)">

            <!-- Date -->
            <div class="col-span-2 text-left">
              <p class="text-sm font-bold text-slate-900 dark:text-white leading-tight">{{ (loan.createdAt || loan.created_at) | date:'dd MMM' }}</p>
              <p class="text-xs text-slate-400 uppercase font-medium mt-0.5">{{ (loan.createdAt || loan.created_at) | date:'yyyy' }}</p>
            </div>

            <!-- Applicant -->
            <div class="col-span-2 min-w-0 text-left">
              <p class="text-sm font-semibold text-slate-900 dark:text-white truncate">
                {{ loan.user?.firstName || '—' }} {{ loan.user?.lastName || '' }}
              </p>
              <p class="text-xs text-slate-400 truncate mt-0.5">{{ loan.user?.email || '—' }}</p>
            </div>

            <!-- Ref -->
            <div class="col-span-2 min-w-0 text-left">
              <p class="text-xs font-mono text-slate-800 dark:text-slate-100 truncate">{{ loan.reference?.substring(0, 14) || loan.id?.substring(0, 8) || '—' }}</p>
              <p class="text-[11px] text-slate-400 font-mono mt-0.5 truncate">{{ loan.userGhanaCard || loan.user?.ghanaCardNumber || '—' }}</p>
            </div>

            <!-- Product -->
            <div class="col-span-2 min-w-0 text-left">
              <p class="text-xs font-semibold text-slate-800 dark:text-slate-100 truncate">{{ loan.product?.name || '—' }}</p>
            </div>

            <!-- Amount -->
            <div class="col-span-1 text-left">
              <p class="text-sm font-bold text-slate-900 dark:text-white">₵{{ (loan.amount || loan.principal_amount || 0) | number:'1.0-0' }}</p>
            </div>

            <!-- Status -->
            <div class="col-span-2 flex justify-start">
              <span class="text-xs font-bold px-2 py-1 rounded-md uppercase tracking-normal whitespace-nowrap border"
                [class]="loan.status | loanStatusStyle">
                {{ loan.status | loanStatusLabel }}
              </span>
            </div>

            <!-- Actions -->
            <div class="col-span-1 flex justify-center">
              <button (click)="onViewLoanProduct(loan); $event.stopPropagation()"
                class="px-2 py-1 text-xs font-semibold text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700 rounded hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 hover:border-slate-300 dark:border-slate-600 transition-colors">
                View
              </button>
            </div>

          </div>
          }
          @if (!isApplicationsLoading && (!loans.data || loans.data.length === 0)) {
          <div class="flex flex-col items-center justify-center py-20 text-center">
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">No applications found</p>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">No loan applications for this institution yet</p>
          </div>
          }
          }

        </div>
      </div>

      <!-- Pagination -->
      @if (loans.data.length > 0) {
      <app-pagination [totalItems]="loans.meta.total || 0" [itemsPerPage]="loans.meta.perPage || 10"
        [currentPage]="loans.meta.page || 1" (pageChange)="onPageChange($event)"></app-pagination>
      }
    </div>
    }

    <!-- ALL PRODUCTS VIEW -->
    @if (currentView === 'products') {
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
        <h2 class="text-sm font-bold uppercase tracking-widest text-primary-800 dark:text-primary-400">All Products</h2>
        <button (click)="fetchPaginatedProducts()"
          class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>

          <span>Refresh</span>
        </button>
      </div>

      <!-- Search -->
      <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-1 max-w-md">
            <form [formGroup]="productSearchQuery" (ngSubmit)="onProductSearchEnter($event)">
              <app-search [placeholder]="'Search products by name or code...'" formControlName="keyword"></app-search>
            </form>
          </div>
        </div>
      </div>

      <!-- Products Table -->
      <div class="overflow-x-auto min-h-[400px]">
        <div class="min-w-[700px]">

          <!-- Header -->
          <div class="grid grid-cols-12 gap-x-4 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 px-6 py-3">
            <div class="col-span-1"></div>
            <div class="col-span-3 text-left">
              <p class="text-xs font-semibold text-slate-400">Product</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Category</p>
            </div>
            <div class="col-span-3 text-left">
              <p class="text-xs font-semibold text-slate-400">Details</p>
            </div>
            <div class="col-span-2 text-left">
              <p class="text-xs font-semibold text-slate-400">Status</p>
            </div>
            <div class="col-span-1"></div>
          </div>

          <!-- Rows -->
          @if (isProductsLoading) {
          <div class="flex items-center justify-center py-16">
            <app-progress-loader></app-progress-loader>
          </div>
          }
          @if (!isProductsLoading) {
          @for (product of products.data; track product.id) {
          <div class="grid grid-cols-12 gap-x-4 px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 items-center transition-colors cursor-pointer group"
            (click)="onViewProduct(product)">

            <!-- Icon -->
            <div class="col-span-1 flex justify-center">
              <div class="w-8 h-8 rounded-lg flex items-center justify-center text-white text-[10px] font-bold bg-primary-800">
                {{ product.name?.charAt(0)?.toUpperCase() || 'P' }}
              </div>
            </div>

            <!-- Name -->
            <div class="col-span-3 min-w-0 text-left">
              <p class="text-sm font-semibold text-slate-900 dark:text-white truncate">{{ product.name }}</p>
              @if (product.code) {
              <p class="text-[10px] text-slate-400 font-mono mt-0.5">{{ product.code }}</p>
              }
            </div>

            <!-- Category -->
            <div class="col-span-2 flex justify-start">
              @if (product.category) {
              <span class="px-2 py-0.5 rounded text-[10px] font-semibold bg-slate-100 dark:bg-slate-900 text-slate-600 dark:text-slate-400 uppercase tracking-wide">
                {{ product.category.name }}
              </span>
              } @else {
              <span class="text-slate-400 text-xs">—</span>
              }
            </div>

            <!-- Details -->
            <div class="col-span-3 text-left">
              <div class="flex flex-wrap items-center justify-start gap-x-2 gap-y-0.5 text-[10px] text-slate-600 dark:text-slate-400">
                @if (product.interestRate !== null && product.interestRate !== undefined) {
                <span class="font-semibold text-slate-800 dark:text-slate-100">{{ product.interestRate }}% interest</span>
                }
                @if (product.maxTenure !== null && product.maxTenure !== undefined) {
                <span class="text-slate-300">·</span>
                <span>{{ product.maxTenure }} months</span>
                }
                @if (product.repaymentMode) {
                <span class="text-slate-300">·</span>
                <span>{{ product.repaymentMode }}</span>
                }
              </div>
            </div>

            <!-- Status -->
            <div class="col-span-2 flex justify-start">
              <span class="px-2 py-0.5 rounded-md text-[9px] font-bold border uppercase tracking-widest whitespace-nowrap"
                [ngClass]="product.isActive ? 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900' : 'bg-rose-50 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-900'">
                {{ product.isActive ? 'Active' : 'Inactive' }}
              </span>
            </div>

            <!-- Arrow -->
            <div class="col-span-1 flex justify-end">
              <svg class="w-3.5 h-3.5 text-slate-300 group-hover:text-slate-500 dark:text-slate-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>

          </div>
          }
          @if (!isProductsLoading && (!products.data || products.data.length === 0)) {
          <div class="flex flex-col items-center justify-center py-20 text-center">
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">No products found</p>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">This institution has no products yet</p>
          </div>
          }
          }
        </div>
      </div>

      <!-- Pagination -->
      @if (products.data && products.data.length > 0) {
      <div class="border-t border-slate-200 dark:border-slate-700 px-6 py-4">
        <app-pagination [totalItems]="products.meta.total || 0" [itemsPerPage]="products.meta.perPage || 10"
          [currentPage]="products.meta.page || 1" (pageChange)="onProductPageChange($event)"></app-pagination>
      </div>
      }
    </div>
    }
</section>

<!-- Delete Member Confirmation -->
@if (isDeleteConfirmation && selectedMember) {
<app-confirmation-dialog [title]="'Delete Member'"
  [message]="'Are you sure you want to delete this member? This action cannot be undone.'"
  [itemName]="selectedMember.firstName + ' ' + selectedMember.lastName" [confirmText]="'Delete'" [cancelText]="'Cancel'"
  [type]="'danger'" (onConfirm)="confirmDelete()" (onCancel)="cancelDelete()"></app-confirmation-dialog>
}

<!-- Disable/Enable Member Confirmation -->
@if (isDisableConfirmation && selectedMember) {
<app-confirmation-dialog [title]="getMemberStatusAction() + ' Member'" [message]="getMemberStatusMessage()"
  [itemName]="selectedMember.firstName + ' ' + selectedMember.lastName" [confirmText]="getMemberStatusAction()"
  [cancelText]="'Cancel'" [type]="selectedMember.isActive ? 'warning' : 'info'" (onConfirm)="confirmDisable()"
  (onCancel)="cancelDisable()"></app-confirmation-dialog>
}

<!-- Resend Verification Link Confirmation -->
@if (isResendConfirmation && selectedMember) {
<app-confirmation-dialog [title]="'Resend Verification Link'"
  [message]="'Are you sure you want to resend the verification link to this member?'"
  [itemName]="selectedMember.firstName + ' ' + selectedMember.lastName" [confirmText]="'Resend Link'"
  [cancelText]="'Cancel'" [type]="'info'" (onConfirm)="confirmResend()"
  (onCancel)="cancelResend()"></app-confirmation-dialog>
}

<!-- Reset PIN Confirmation -->
@if (isResetPinConfirmation && selectedMember) {
<app-confirmation-dialog [title]="'Reset PIN'"
  [message]="'Are you sure you want to reset this member\'s PIN? They will need to set a new one.'"
  [itemName]="selectedMember.firstName + ' ' + selectedMember.lastName" [confirmText]="'Reset PIN'"
  [cancelText]="'Cancel'" [type]="'warning'" (onConfirm)="confirmResetPin()"
  (onCancel)="cancelResetPin()"></app-confirmation-dialog>
}

<!-- View Loan Overlay -->
@if (isViewProduct && viewLoan) {
<div
  class="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-[9999] p-4 backdrop-blur-sm">
  <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
    <app-view-new-application (onClose)="onCloseApplication()" [loanInfo]="viewLoan"></app-view-new-application>
  </div>
</div>
}

<!-- View Member Modal -->
@if (isViewMember && selectedMember) {
<div class="fixed inset-0 flex items-center justify-center z-[9999] p-4 backdrop-blur-sm bg-slate-950/40">
  <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden">

    <!-- Hero Header -->
    <div class="flex-shrink-0">
      <!-- Gradient Banner with name inside -->
      <div class="relative px-6 py-5 flex items-center gap-4 bg-gradient-to-br from-primary-800 to-primary">
        <!-- Avatar -->
        @if (selectedMember.userImage) {
        <img [src]="selectedMember.userImage" alt="Profile"
          class="w-16 h-16 rounded-xl object-cover flex-shrink-0 border-2 border-white/30 shadow-lg" />
        } @else {
        <div class="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 border-2 border-white/30 shadow-lg text-primary-800 dark:text-white text-xl font-bold bg-white dark:bg-slate-800/10">
          {{ selectedMember.firstName?.charAt(0) }}{{ selectedMember.lastName?.charAt(0) }}
        </div>
        }
        <!-- Name & meta -->
        <div class="min-w-0 flex-1">
          <h2 class="text-lg font-bold text-white leading-tight">
            {{ selectedMember.firstName }} {{ selectedMember.lastName }}
            @if (selectedMember.otherName) {
            <span class="text-white/60 font-normal text-sm ml-1">({{ selectedMember.otherName }})</span>
            }
          </h2>
          <div class="flex items-center gap-2 mt-1.5 flex-wrap">
            <span class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-bold bg-white dark:bg-slate-800/15 text-primary-800 dark:text-white border border-white/20">
              <span class="w-1.5 h-1.5 rounded-full"
                [ngClass]="selectedMember.isActive ? 'bg-emerald-400' : 'bg-rose-400'"></span>
              {{ selectedMember.isActive ? 'Active' : 'Inactive' }}
            </span>
            @if (selectedMember.gender) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-white dark:bg-slate-800/15 text-primary-800 dark:text-white border border-white/20">
              {{ selectedMember.gender }}
            </span>
            }
            @if (selectedMember.kyc?.occupation) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-white dark:bg-slate-800/15 text-primary-800 dark:text-white border border-white/20">
              {{ selectedMember.kyc.occupation }}
            </span>
            }
          </div>
        </div>
        <!-- Close Button -->
        <button (click)="closeViewMember()"
          class="flex-shrink-0 p-1.5 rounded-lg bg-white dark:bg-slate-800/10 hover:bg-white/80 text-primary-800 dark:text-white transition-colors" title="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Scrollable Content -->
    <div class="overflow-y-auto flex-1 px-6 pb-6 space-y-5">

      <!-- Personal Information -->
      <div>
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1 h-4 bg-primary-800 rounded-full"></div>
          <h3 class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest">Personal Information</h3>
        </div>
        <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4 grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
          <div>
            <p class="text-xs font-semibold text-slate-400">Email</p>
            <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100 break-all">{{ selectedMember.email || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold text-slate-400">Phone</p>
            <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100 font-mono">{{ selectedMember.mobileNumber || '—' }}</p>
          </div>
          @if (selectedMember.dateOfBirth) {
          <div>
            <p class="text-xs font-semibold text-slate-400">Date of Birth</p>
            <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.dateOfBirth | date:'dd MMM yyyy' }}</p>
          </div>
          }
          @if (selectedMember.gender) {
          <div>
            <p class="text-xs font-semibold text-slate-400">Gender</p>
            <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.gender }}</p>
          </div>
          }
        </div>
      </div>

      <!-- ID & KYC -->
      <div>
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1 h-4 bg-primary-800 rounded-full"></div>
          <h3 class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest">ID & KYC</h3>
        </div>
        <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4 space-y-4">
          <!-- Ghana Card row -->
          <div class="flex flex-col md:flex-row md:items-start gap-4">
            <!-- Card details -->
            <div class="flex-1 grid grid-cols-2 gap-x-6 gap-y-4">
              @if (selectedMember.ghanaCardNumber) {
              <div>
                <p class="text-xs font-semibold text-slate-400">Ghana Card No.</p>
                <p class="mt-1 text-sm font-bold text-slate-800 dark:text-slate-100 font-mono">{{ selectedMember.ghanaCardNumber }}</p>
                <span class="inline-flex items-center gap-1 mt-1 text-[10px] font-bold uppercase"
                  [ngClass]="selectedMember.isGhanaCardVerified ? 'text-emerald-600' : 'text-amber-600'">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    @if (selectedMember.isGhanaCardVerified) {
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    } @else {
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                    }
                  </svg>
                  {{ selectedMember.isGhanaCardVerified ? 'Verified' : 'Unverified' }}
                </span>
              </div>
              }
              @if (selectedMember.kyc) {
              <div>
                <p class="text-xs font-semibold text-slate-400">Valid Period</p>
                <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.kyc.validFrom | date:'dd MMM yyyy' }}</p>
                <p class="text-xs text-slate-400">to {{ selectedMember.kyc.validTo | date:'dd MMM yyyy' }}</p>
              </div>
              <div>
                <p class="text-xs font-semibold text-slate-400">Address</p>
                <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.kyc.address || '—' }}</p>
              </div>
              @if (selectedMember.kyc.refNumber) {
              <div class="col-span-2">
                <p class="text-xs font-semibold text-slate-400">KYC Reference</p>
                <p class="mt-1 text-xs font-mono text-slate-600 dark:text-slate-400 break-all">{{ selectedMember.kyc.refNumber }}</p>
              </div>
              }
              }
            </div>
            <!-- Ghana Card Image -->
            @if (selectedMember.ghanaCardImage) {
            <div class="flex-shrink-0">
              <p class="text-xs font-semibold text-slate-400 mb-2">Ghana Card</p>
              <img [src]="selectedMember.ghanaCardImage" alt="Ghana Card"
                class="w-48 h-28 object-cover rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm cursor-pointer hover:opacity-90 transition-opacity" />
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Financial Information -->
      <div>
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1 h-4 bg-primary-800 rounded-full"></div>
          <h3 class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest">Financial Information</h3>
        </div>
        <div class="grid grid-cols-3 gap-3">
          <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4 text-center">
            <p class="text-xs font-semibold text-slate-400">Monthly Income</p>
            <p class="mt-2 text-base font-bold text-slate-900 dark:text-white">GHS {{ selectedMember.monthlyIncome | number:'1.0-0' }}</p>
          </div>
          <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4 text-center">
            <p class="text-xs font-semibold text-slate-400">Credit Score</p>
            <p class="mt-2 text-base font-bold" [ngClass]="(selectedMember.creditScore || 0) >= 600 ? 'text-emerald-600' : (selectedMember.creditScore || 0) >= 300 ? 'text-amber-600' : 'text-slate-500 dark:text-slate-400'">
              {{ selectedMember.creditScore ?? '—' }}
            </p>
          </div>
          <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4 text-center">
            <p class="text-xs font-semibold text-slate-400">Active Loans</p>
            <p class="mt-2 text-base font-bold text-slate-900 dark:text-white">GHS {{ selectedMember.activeLoanSum | number:'1.0-0' }}</p>
          </div>
        </div>
      </div>

      <!-- Account Details -->
      @if (selectedMember.account) {
      <div>
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1 h-4 bg-primary-800 rounded-full"></div>
          <h3 class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest">Settlement Account</h3>
        </div>
        <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 rounded-lg p-4">
          <!-- Account type badge -->
          <div class="flex items-center gap-2 mb-4">
            <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-400 border border-blue-100 dark:border-blue-900 uppercase tracking-wide">
              {{ selectedMember.account.network || selectedMember.account.accountType || 'Account' }}
            </span>
            @if (selectedMember.account.accountType && selectedMember.account.network) {
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 dark:bg-slate-900 text-slate-600 dark:text-slate-400">
              {{ selectedMember.account.accountType }}
            </span>
            }
          </div>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
            @if (selectedMember.account.accountNumber) {
            <div>
              <p class="text-xs font-semibold text-slate-400">Account Number</p>
              <p class="mt-1 text-sm font-bold text-slate-800 dark:text-slate-100 font-mono">{{ selectedMember.account.accountNumber }}</p>
            </div>
            }
            @if (selectedMember.account.accountName) {
            <div>
              <p class="text-xs font-semibold text-slate-400">Account Name</p>
              <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.account.accountName }}</p>
            </div>
            }
            @if (selectedMember.account.bankName) {
            <div>
              <p class="text-xs font-semibold text-slate-400">Bank / Provider</p>
              <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.account.bankName }}</p>
            </div>
            }
            @if (selectedMember.account.createdAt) {
            <div>
              <p class="text-xs font-semibold text-slate-400">Linked On</p>
              <p class="mt-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{{ selectedMember.account.createdAt | date:'dd MMM yyyy' }}</p>
            </div>
            }
          </div>
        </div>
      </div>
      }

      <!-- Documents -->
      @if (selectedMember.documents && selectedMember.documents.length > 0) {
      <div>
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1 h-4 bg-primary-800 rounded-full"></div>
          <h3 class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-widest">Documents</h3>
          <span class="text-[10px] font-semibold text-slate-400 bg-slate-100 dark:bg-slate-900 px-2 py-0.5 rounded-full">{{ selectedMember.documents.length }}</span>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
          @for (doc of selectedMember.documents; track doc; let i = $index) {
          <a [href]="doc" target="_blank" rel="noopener noreferrer"
            class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden hover:border-primary-800/40 hover:shadow-sm transition-all group">
            <div class="w-full h-24 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 flex items-center justify-center overflow-hidden">
              <img [src]="doc" [alt]="'Document ' + (i + 1)" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div class="px-3 py-2 flex items-center justify-between">
              <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">Doc {{ i + 1 }}</p>
              <svg class="w-3.5 h-3.5 text-slate-400 group-hover:text-primary-800 dark:text-primary-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </div>
          </a>
          }
        </div>
      </div>
      }

    </div>
  </div>
  <!-- Backdrop click -->
  <div class="absolute inset-0 -z-10" (click)="closeViewMember()"></div>
</div>
}

<!-- Edit Member Modal -->
@if (isEditMember && selectedMember) {
<div
  class="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-[9999] p-4 backdrop-blur-sm">
  <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col">
    <!-- Modal Header -->
    <div class="flex-shrink-0 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 px-6 py-4 flex items-center justify-between">
      <h2 class="text-lg font-bold text-primary-800 dark:text-primary-400">Edit Member</h2>
      <button (click)="closeEditMember()" class="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 rounded-lg transition-colors" title="Close">
        <svg class="w-6 h-6 text-slate-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="p-6 overflow-y-auto flex-1">
      <!-- Form -->
      <form [formGroup]="editMemberForm" class="space-y-5">
        <!-- Personal Information Section -->
        <div>
          <h3 class="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4 pb-2 border-b border-slate-100 dark:border-slate-700/50">Personal Information</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <app-custom-input [label]="'First Name'" [showLabel]="true" [showAsteric]="true"
                [placeholder]="'Enter first name'"
                formControlName="firstName"></app-custom-input>
              @if (editMemberForm.get('firstName')?.invalid && (editMemberForm.get('firstName')?.touched ||
              editMemberForm.get('firstName')?.dirty)) {
              <div class="text-error text-xs mt-2">First name is required.</div>
              }
            </div>
            <div>
              <app-custom-input [label]="'Last Name'" [showLabel]="true" [showAsteric]="true"
                [placeholder]="'Enter last name'"
                formControlName="lastName"></app-custom-input>
              @if (editMemberForm.get('lastName')?.invalid && (editMemberForm.get('lastName')?.touched ||
              editMemberForm.get('lastName')?.dirty)) {
              <div class="text-error text-xs mt-2">Last name is required.</div>
              }
            </div>
            <div>
              <app-custom-input [label]="'Other Name'" [showLabel]="true"
                [placeholder]="'Enter other name (optional)'"
                formControlName="otherName"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Email Address'" [showLabel]="true" [showAsteric]="true"
                [placeholder]="'Enter email address'"
                formControlName="email"></app-custom-input>
              @if (editMemberForm.get('email')?.invalid && (editMemberForm.get('email')?.touched ||
              editMemberForm.get('email')?.dirty)) {
              <div class="text-error text-xs mt-2">
                @if (editMemberForm.get('email')?.errors?.['required']) {
                Email is required.
                } @else if (editMemberForm.get('email')?.errors?.['email']) {
                Please enter a valid email address.
                }
              </div>
              }
            </div>
            <div>
              <app-custom-input [label]="'Phone Number'" [showLabel]="true" [showAsteric]="true"
                [placeholder]="'Enter phone number'"
                formControlName="mobileNumber"></app-custom-input>
              @if (editMemberForm.get('mobileNumber')?.invalid && (editMemberForm.get('mobileNumber')?.touched ||
              editMemberForm.get('mobileNumber')?.dirty)) {
              <div class="text-error text-xs mt-2">Phone number is required.</div>
              }
            </div>
            <div>
              <app-custom-input [label]="'Date of Birth'" [showLabel]="true" [type]="'date'"
                [placeholder]="'Select date of birth'"
                formControlName="dateOfBirth"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Ghana Card Number'" [showLabel]="true" [showAsteric]="true"
                [placeholder]="'Enter Ghana Card number'"
                formControlName="ghanaCardNumber"></app-custom-input>
              @if (editMemberForm.get('ghanaCardNumber')?.invalid && (editMemberForm.get('ghanaCardNumber')?.touched ||
              editMemberForm.get('ghanaCardNumber')?.dirty)) {
              <div class="text-error text-xs mt-2">Ghana Card number is required.</div>
              }
            </div>
          </div>
        </div>

        <!-- Financial Information Section -->
        <div>
          <h3 class="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4 pb-2 border-b border-slate-100 dark:border-slate-700/50">Financial Information</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <app-custom-input [label]="'Monthly Income'" [showLabel]="true" [type]="'number'"
                [placeholder]="'Enter monthly income'"
                formControlName="monthlyIncome"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Credit Score'" [showLabel]="true" [type]="'number'"
                [placeholder]="'Enter credit score'"
                formControlName="creditScore"></app-custom-input>
            </div>
          </div>
        </div>

        <!-- Account Details Section -->
        <div>
          <h3 class="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4 pb-2 border-b border-slate-100 dark:border-slate-700/50">Account Details</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <app-custom-input [label]="'Account Number'" [showLabel]="true"
                [placeholder]="'Enter account number'"
                formControlName="accountNumber"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Account Name'" [showLabel]="true"
                [placeholder]="'Enter account name'"
                formControlName="accountName"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Bank Name'" [showLabel]="true"
                [placeholder]="'Enter bank name'" formControlName="bankName"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Account Type'" [showLabel]="true"
                [placeholder]="'Enter account type'"
                formControlName="accountType"></app-custom-input>
            </div>
            <div>
              <app-custom-input [label]="'Network'" [showLabel]="true"
                [placeholder]="'Enter network'" formControlName="network"></app-custom-input>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="flex items-center justify-end gap-3 pt-4 border-t border-slate-200 dark:border-slate-700">
          <button type="button" (click)="closeEditMember()"
            class="px-6 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
            Cancel
          </button>
          <button type="button" (click)="saveMemberChanges()" [disabled]="editMemberForm.invalid"
            class="px-6 py-2.5 text-sm font-medium text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-primary-800 hover:bg-primary-900">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}